export default __webpack_public_path__ + "images/SLD.030bb9b.png";